import {action} from 'mobx';
import {Context} from 'egg';
import {Country} from '../../../const/env';

export interface IShareLineStoreInitData {
  country: Country;
}

export default class ShareLineStore {
  public root: any;
  public country: Country;

  constructor(root: any, initialState: IShareLineStoreInitData) {
    this.root = root;
    this.country = initialState && initialState.country;
    // console.log('ShareLineStore, init:',this.root );
  }

  @action.bound
  public async ssrInit(ctx: Context) {
    this.country = ctx.envi.country;
    // nothing
  }

  public toJson() {
    return {country: this.country};
  }

}
